import { useEffect, useState } from "react";
import Tabs from "../../components/Tabs/Tabs";
import Tab from "../../components/Tabs/Components/Tab";
import TabPanel from "../../components/Tabs/Components/TabPanel";
import InfractionGeneral from "./Components/InfractionGeneral";
import { Home } from "iconsax-react";

const Infractions: React.FC<{}> = () => {
  const [tab, setTab] = useState<number>(0);

  useEffect(() => {
    return () => {
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <div className="-mt-6">
      <InfractionGeneral />
    </div>
  );
};

export default Infractions;
